export default {
  pageDescription: {
    id: 'policies_and_eligible_insurances_page_description',
    defaultMessage: 'Check plans and warranties here',
  },
  eligibleDevices: {
    id: 'policies_and_eligible_insurances_eligible_devices',
    defaultMessage: 'Eligible devices',
  },
  yourProtectionPlans: {
    id: 'policies_and_eligible_insurances_your_protection_plans',
    defaultMessage: 'Your Protection Plans',
  },
}
